<template>
	<div>
		<el-card class="box-card maincard">
			<el-row>
				<el-col :span="2">
					<el-button size="mini" type="primary" @click="openAddRightDialog"
						><i class="el-icon-plus"></i>&nbsp;新增权限</el-button
					>
				</el-col>
				<el-col :span="22">
					<el-alert
						title="权限与系统功能挂钩，因此此功能应仅由开发人员操作。"
						type="warning"
						:closable="false">
					</el-alert>
				</el-col>
			</el-row>
			<el-table
				:data="rightInfoList"
				height="600"
				border
				style="width: 100%"
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<el-table-column prop="rightId" label="编号" width="50">
				</el-table-column>
				<el-table-column
					prop="rightName"
					label="权限名称"
					width="180"
					show-overflow-tooltip></el-table-column>
				<el-table-column
					prop="symbol"
					label="权限标识"
					width="180"
					show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					prop="notes"
					label="权限说明"
					width="350"
					show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					prop="creatorName"
					label="创建者"
					width="120"
					show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					prop="createTime"
					label="创建时间"
					width="160"
					show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag size="mini" type="primary">{{
							scope.row.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="拥有该权限的用户">
					<template slot-scope="scope">
						<el-tag
							size="mini"
							type="success"
							class="tiedTag"
							v-for="user in scope.row.userList"
							:key="user.userId"
							>{{ user.userName }}</el-tag
						>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<!--新增权限-->
		<el-dialog
			title="新增权限"
			:visible.sync="addRightVisible"
			width="40%"
			:show-close="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false">
			<el-form
				:label-position="'right'"
				label-width="100px"
				:model="addingRight"
				:rules="rules"
				ref="addRightForm">
				<el-form-item label="权限名称:" prop="rightName">
					<el-input
						v-model="addingRight.rightName"
						placeholder="请输入权限名称"
						maxlength="10"
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="权限标识:" prop="symbol">
					<el-input
						v-model="addingRight.symbol"
						placeholder="请输入权限标识"
						maxlength="25"
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="权限说明:" prop="notes">
					<el-input
						v-model="addingRight.notes"
						placeholder="请输入权限说明"
						maxlength="50"
						show-word-limit></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="addNewRight">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "rightView",
	data() {
		return {
			rightInfoList: [], //权限信息列表
			loading: false, //表格加载动画
			addRightVisible: false, //新增权限对话框是否可见
			addingRight: { rightName: "", symbol: "", notes: "" }, //待新增的权限
			rules: {
				rightName: [
					{ required: true, message: "请输入权限名称", trigger: "blur" },
				],
				symbol: [
					{ required: true, message: "请输入权限标识", trigger: "blur" },
				],
				notes: [{ required: true, message: "请输入权限说明", trigger: "blur" }],
			}, //新增表单的规则
		}
	},
	mounted() {
		//获取权限列表信息
		this.getRightInfoList()
	},
	methods: {
		//获取所有权限列表
		getRightInfoList() {
			this.loading = true
			this.$http.post("right/rightUsers").then(response => {
				let data = response.data
				if (data) {
					this.rightInfoList = data
				}
				this.loading = false
			}).catch(err => err)
		},
		//新增对话框关闭，清空内容
		handleClose() {
			this.addRightVisible = false
			this.$refs.addRightForm.resetFields()
		},
		//打开新增对话框
		openAddRightDialog() {
			this.$message.warning(
				"此功能关联系统功能，应由开发人员操作，请谨慎操作。"
			)
			this.addRightVisible = true
		},
		//执行新增权限
		addNewRight() {
			//首先验证表格
			this.$refs.addRightForm.validate(async valid => {
				if (!valid) {
					console.log("存在不符合要求的数据。")
					return
				}
				//询问用户是否执行操作
				const confirmresult = await this.$confirm(
					"即将新增权限信息，权限新增后不可删除，请确定是否继续",
					"提示",
					{
						confirmButtonText: "确定新增",
						cancelButtonText: "取消",
						type: "warning",
					}
				).catch(err => err)
				if (confirmresult !== "confirm") {
					return this.$message.info("已取消操作。")
				}
				this.$http.post("right/addRight", this.addingRight).then(response => {
					let data = response.data
					if (data) {
						//添加成功
						this.handleClose()
						this.getRightInfoList()
						this.$message.success("操作成功！")
					}
				}).catch(err => err)
			})
		},
	},
}
</script>

<style></style>
